import { render } from "./sceneSwitchButton.vue?vue&type=template&id=86be2392&scoped=true&ts=true"
import script from "./sceneSwitchButton.vue?vue&type=script&lang=ts"
export * from "./sceneSwitchButton.vue?vue&type=script&lang=ts"

import "./sceneSwitchButton.vue?vue&type=style&index=0&id=86be2392&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86be2392"]])

export default __exports__